<app-header></app-header>
<div class="wrapper">
  <app-grid-simmer *ngIf="shimmerStatus.category"></app-grid-simmer>
  <div class="home-page mt-4 multi-slider-section" *ngIf="!shimmerStatus.category">
    <div *ngIf="subcategory?.length > 0">
      <section class="multi-slider">
        <div class="" *ngFor="let category of subcategory; let c = index">
          <div class="">
            <div class="section-head" *ngIf="category?.content?.length > 0" (mouseenter)="playOff()">
              <a [routerLink]="
                  category.subcategoryCount > 0
                    ? ['/category', category.slug]
                    : ['/list', category.slug]
                " [queryParams]="{ type: apiParam.type }">
                <h2>{{ category | languageTranslate }}</h2>
              </a>

              <a *ngIf="category?.content?.length > 5" href="javascript:void(0)" class="text-primary view-all-link"
                [routerLink]="
                  category.subcategoryCount > 0
                    ? ['/category', category.slug]
                    : ['/list', category.slug]
                " [queryParams]="{ type: apiParam.type }">
                {{ "HOME.VIEW_ALL" | translate }}
              </a>
            </div>

            <div class="populer-slider" id="slider-top">
              <owl-carousel-o [options]="watching">
                <ng-container *ngFor="let watch of category.content; let i = index">
                  <ng-template carouselSlide [id]="watch.public_id">
                    <div class="series-box">
                      <app-grid [data]="watch" [gridType]="'landscape'"></app-grid>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </div>
          </div>
        </div>
      </section>
      <!-- <div class="text-center" *ngIf="show === true" (mouseenter)="playOff()">
        <button type="button" class="btn btn-theme" (click)="viewMoreData()">
          View More
        </button>
      </div> -->
      <app-grid-simmer *ngIf="loadMore"></app-grid-simmer>
    </div>
  </div>
  <div class="record-not-available" *ngIf="
      (subcategory?.length == 0 || subcategory[0]?.content.length == 0) &&
      shimmerStatus.category === false
    ">
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </div>
  </div>
</div>
<app-footer></app-footer>